import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface VisitSelectionOption<T = unknown> {
  label: string;
  description?: string;
  value: T;
}

export interface VisitSelectionDialogData<T = unknown> {
  title: string;
  message: string;
  options: VisitSelectionOption<T>[];
  confirmLabel: string;
}

@Component({
  selector: 'app-visit-selection-dialog',
  templateUrl: './visit-selection-dialog.component.html',
  styleUrls: ['./visit-selection-dialog.component.scss'],
})
export class VisitSelectionDialogComponent<T = unknown> {
  selected: VisitSelectionOption<T> = undefined;

  constructor(@Inject(MAT_DIALOG_DATA) public data: VisitSelectionDialogData<T>) {}
}
